import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import Grid from "@material-ui/core/Grid";
import { PageTitle } from '../../atomic/PageHeader/PageTitle';
import { useTranslation } from 'react-i18next';
import PageHeaderAtm from '../../atomic/PageHeader/PageHeader';
import { REPUTATION_MANAGEMENT, CONTENT } from '../../../constants/appUrls.constants';
import { Animated } from "react-animated-css";
import Container from "@material-ui/core/Container";
import { 
    Paper, Typography, Chip, CircularProgress, 
    Backdrop, Card, CardContent, Divider, Box,
    LinearProgress, IconButton, Collapse,
    Dialog, DialogTitle, DialogContent, TextField,
    Snackbar, Select, MenuItem, FormControl, InputLabel,
    Tooltip,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { 
    reputationManagementReview, 
    reputationManagementReviewStatistics,
    reputationManagementReviewClear,
    reputationManagementReviewStatisticsClear,
    reputationManagementList,
    reputationManagementSync,
    reputationManagementListClear,
    reputationManagementSyncClear
} from '../../../redux/actions/Network/ReputationManagement/ReputationManagement.actions';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/bg';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/ka';
import 'moment/locale/de';
import 'moment/locale/pl';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/tr';
import Pagination from '@material-ui/lab/Pagination';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import FilterListIcon from '@material-ui/icons/FilterList';
import SettingsIcon from '@material-ui/icons/Settings';
import ButtonAtm from '../../atomic/Button/Button';
import { openAI, clearOpenAI } from '../../../redux/actions/General/OpenAI/openAIActions';
import { getAppLang } from '../../../utils';
import { Alert } from '@material-ui/lab';
import { SelectValidator } from 'react-material-ui-form-validator';
import InputAtm from '../../atomic/Input/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {Menu} from '@material-ui/core';
import { getProperty } from '../../../utils';
import { getLanguages } from '../../../redux/actions/languageActions';
import NotAllowedPage from "../Global/NotAllowedPage/NotAllowedPage";

const MuiDialogTitle = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}))((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <DialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button" />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
});

const MuiDialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(DialogContent);

function AlertSnackbar(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#d71f26',
    },
    reviewCard: {
        marginBottom: theme.spacing(2),
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        }
    },
    reviewHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    reviewScore: {
        backgroundColor: '#4caf50',
        color: '#fff',
        padding: '4px 12px',
        borderRadius: 20,
        fontWeight: 'bold',
        fontSize: 14,
        display: 'inline-flex',
        alignItems: 'center',
    },
    reviewScoreLow: {
        backgroundColor: '#f44336',
    },
    reviewScoreMedium: {
        backgroundColor: '#ff9800',
    },
    positiveChip: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32',
        marginRight: theme.spacing(0.5),
        fontSize: 14,
        marginTop: theme.spacing(0.5)
    },
    negativeChip: {
        backgroundColor: '#ffebee',
        color: '#c62828',
        marginRight: theme.spacing(0.5),
        fontSize: 14,
        marginTop: theme.spacing(0.5)
    },
    statisticsCard: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3),
        borderRadius: 12,
    },
    scoreCircle: {
        width: 120,
        height: 120,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 28,
        fontWeight: 'bold',
        color: '#fff',
        margin: '0 auto',
    },
    categoryScore: {
        marginBottom: theme.spacing(1.5),
    },
    progressBar: {
        height: 8,
        borderRadius: 4,
    },
    filterSection: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: 8,
    },
    detailsSection: {
        backgroundColor: '#fafafa',
        padding: theme.spacing(2),
        borderRadius: 8,
        marginTop: theme.spacing(2),
    },
    reviewListContainer: {
        maxHeight: 'calc(100vh - 200px)',
        overflowY: 'auto',
        paddingRight: theme.spacing(1),
    },
    selectedReview: {
        border: '2px solid #d71f26',
    },
    sentimentPositive: {
        color: '#4caf50',
        fontWeight: 500,
    },
    sentimentNegative: {
        color: '#f44336',
        fontWeight: 500,
    },
    sentimentNeutral: {
        color: '#9e9e9e',
        fontWeight: 500,
    },
    categorySection: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: '#f5f5f5',
        borderRadius: 8,
    },
    reviewText: {
        backgroundColor: '#fff',
        padding: theme.spacing(2),
        borderRadius: 8,
        border: '1px solid #e0e0e0',
        marginTop: theme.spacing(2),
    },
    noReviewSelected: {
        padding: theme.spacing(6),
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 400,
    },
    noChannelContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
    },
    channelCard: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: 8,
        border: '1px solid #e0e0e0',
    },
    channelLogo: {
        width: 40,
        height: 40,
        objectFit: 'contain',
        marginRight: theme.spacing(2),
    },
    channelStatusActive: {
        color: '#4caf50',
    },
    channelStatusInactive: {
        color: '#f44336',
    },
    settingsButton: {
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
    },
    channelPaper: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        borderRadius: 12,
        border: '1px solid #e0e0e0',
        transition: 'all 0.3s ease',
        '&:hover': {
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            borderColor: '#d71f26',
        }
    },
    channelHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderBottom: '1px solid #f0f0f0',
    },
    channelLogoContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    channelLogoWrapper: {
        width: "100%",
        height: 75,
        borderRadius: 12,
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1),
        border: '1px solid #eee',
    },
    channelLogoImg: {
        width: 125,
        height: 90,
        objectFit: 'contain',
    },
    channelName: {
        fontWeight: 600,
        fontSize: 18,
        color: '#333',
    },
    channelStatusChip: {
        fontWeight: 500,
        fontSize: 12,
    },
    activeChip: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32',
        border: '1px solid #a5d6a7',
    },
    inactiveChip: {
        backgroundColor: '#fff3e0',
        color: '#e65100',
        border: '1px solid #ffcc80',
    },
    parameterField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            backgroundColor: '#fafafa',
            transition: 'all 0.2s ease',
            '&:hover': {
                backgroundColor: '#fff',
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
            }
        },
        '& .MuiInputLabel-root': {
            fontSize: 14,
        }
    },
    saveButton: {
        marginTop: theme.spacing(1),
        borderRadius: 8,
        padding: '10px 24px',
        fontWeight: 600,
        textTransform: 'none',
    },
    parameterSection: {
        backgroundColor: '#fafafa',
        borderRadius: 8,
        padding: theme.spacing(2),
    },
    barGreen: {
        backgroundColor: '#4caf50 !important',
    },
    barOrange: {
        backgroundColor: '#ff9800 !important',
    },
    barRed: {
        backgroundColor: '#f44336 !important',
    },
}));

const useModernFilterStyles = makeStyles((theme) => ({
    filterPaper: {
        position: 'relative',
        background: 'linear-gradient(135deg, #fff 0%, #f8fafc 100%)',
        // border: '1px solid #e2e8f0',
        borderRadius: 4,
        boxShadow: '0 8px 32px rgba(25, 118, 210, 0.07)',
        padding: 24,
        marginBottom: 36,
        overflow: 'visible',
    },
    accentBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 5,
        width: '100%',
        borderRadius: '20px 20px 0 0',
        background: 'linear-gradient(90deg, #d71f26 0%, #ff6b6b 100%)',
    },
    filterHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        marginBottom: 8,
    },
    filterHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    filterIcon: {
        width: 44,
        height: 44,
        borderRadius: 12,
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 16px rgba(215, 31, 38, 0.18)',
    },
    filterTitle: {
        fontWeight: 800,
        color: '#1e293b',
        fontSize: 20,
        letterSpacing: '-0.01em',
    },
    filterDesc: {
        color: '#64748b',
        fontSize: 13,
        marginTop: 2,
    },
    filterCollapse: {
        marginTop: 18,
    },
    filterFieldLabel: {
        fontWeight: 700,
        color: '#475569',
        fontSize: 12,
        marginBottom: 8,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        display: 'block',
    },
    filterInput: {
        borderRadius: 12,
        background: '#fff',
    },
    filterActions: {
        marginTop: 24,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 16,
        borderTop: '1px solid #e2e8f0',
        paddingTop: 18,
    },
    filterBtn: {
        borderRadius: 12,
        fontWeight: 700,
        minWidth: 130,
        padding: '10px 22px',
        textTransform: 'none',
        fontSize: 15,
        boxShadow: '0 2px 8px rgba(215, 31, 38, 0.08)',
    },
    filterBtnApply: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        color: '#fff',
        border: 'none',
        '&:hover': {
            background: 'linear-gradient(135deg, #c81d24 0%, #ff4757 100%)',
        }
    },
    filterBtnClear: {
        background: '#f1f5f9',
        color: '#334155',
        border: '1px solid #e2e8f0',
        '&:hover': {
            background: '#e2e8f0',
        },
        '&:disabled': {
            background: "#b4b4b4ee"
        }
    }
}));

// Kanal Ekleme/Düzenleme Modal
const ChannelSetupModal = ({ open, onClose, channels, onSave, syncFetching, syncData, syncError }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [channelParams, setChannelParams] = useState({});

    useEffect(() => {
        if (channels && channels.length > 0) {
            const initialParams = {};
            channels.forEach(channel => {
                initialParams[channel.id] = {};
                if (channel.parameterArray) {
                    Object.keys(channel.parameterArray).forEach(paramKey => {
                        const existingValue = channel.channelDetail?.parameterArray?.[paramKey] || '';
                        initialParams[channel.id][paramKey] = existingValue;
                    });
                }
            });
            setChannelParams(initialParams);
        }
    }, [channels]);

    // useEffect(() => {
    //     if (syncData?.status === 200) {
    //         onClose();
    //     }
    // }, [syncData, onClose]);

    const handleParamChange = (channelId, paramKey, value) => {
        setChannelParams(prev => ({
            ...prev,
            [channelId]: {
                ...prev[channelId],
                [paramKey]: value
            }
        }));
    };

    const handleSave = (channelId) => {
        const params = {
            channel_id: channelId,
            ...channelParams[channelId]
        };
        onSave(params);
    };

    return (
        <Dialog onClose={onClose} open={open} maxWidth="md" fullWidth>
            <MuiDialogTitle className="red-bottom-border" onClose={onClose}>
                {t('enw-reputation_management-channel_setup')}
            </MuiDialogTitle>
            <MuiDialogContent style={{ backgroundColor: '#f5f5f5', padding: 24 }}>
                {syncData?.status === 200 && (
                    <Alert severity="success" style={{ marginBottom: 16, borderRadius: 8 }}>
                        {t('enw-reputation_management-channel_saved')}
                    </Alert>
                )}
                {syncError && (
                    <Alert severity="error" style={{ marginBottom: 16, borderRadius: 8 }}>
                        {syncError?.response?.data?.message || t('enw-error-message')}
                    </Alert>
                )}
                <Alert severity="info" style={{ marginBottom: 24, borderRadius: 8 }} icon={<i className="fas fa-info-circle" />}>
                    {t('enw-reputation_management-channel_info')}
                </Alert>
                
                {channels?.map((channel) => (
                    <Paper key={channel.id} className={classes.channelPaper} elevation={0}>
                        {/* Channel Header */}
                        <Box className={classes.channelHeader}>
                            <Box className={classes.channelLogoContainer}>
                                <Box className={classes.channelLogoWrapper}>
                                    <img 
                                        src={channel.logoUrl} 
                                        alt={channel.name}
                                        className={classes.channelLogoImg}
                                    />
                                </Box>
                                <Box>
                                    <Typography className={classes.channelName}>
                                        {channel.name}
                                    </Typography>
                                </Box>
                            </Box>
                            <Chip 
                                icon={
                                    channel.channelDetail?.fetchStatus?.status === 1 
                                        ? <i className="fas fa-check-circle" style={{ fontSize: 14, color: '#2e7d32', marginTop: 5 }} />
                                        : <i className="fas fa-exclamation-circle" style={{ fontSize: 14, color: '#e65100', marginTop: 5 }} />
                                }
                                label={channel.channelDetail?.fetchStatus?.status === 1 
                                    ? t('enw-input-active') 
                                    : t('enw-input-inactive')
                                } 
                                size="small"
                                className={`${classes.channelStatusChip} ${
                                    channel.channelDetail?.fetchStatus?.status === 1 
                                        ? classes.activeChip 
                                        : classes.inactiveChip
                                }`}
                            />
                        </Box>
                        
                        {/* Parameters Section */}
                        <Box className={classes.parameterSection}>
                            <Grid container spacing={2} alignItems="center">
                                {channel.parameterArray && Object.keys(channel.parameterArray).map((paramKey) => (
                                    <Grid item xs={12} sm={6} md={8} key={paramKey}>
                                        <TextField
                                            fullWidth
                                            label={channel.parameterArray[paramKey].name}
                                            variant="outlined"
                                            size="small"
                                            className={classes.parameterField}
                                            value={channelParams[channel.id]?.[paramKey] || ''}
                                            onChange={(e) => handleParamChange(
                                                channel.id, 
                                                paramKey,
                                                e.target.value
                                            )}
                                            placeholder={`${channel.parameterArray[paramKey].name}`}
                                            InputProps={{
                                                startAdornment: (
                                                    <i 
                                                        className="fas fa-link" 
                                                        style={{ 
                                                            marginRight: 8, 
                                                            color: '#9e9e9e',
                                                            fontSize: 14 
                                                        }} 
                                                    />
                                                ),
                                            }}
                                        />
                                    </Grid>
                                ))}
                                <Grid item xs={12} sm={6} md={4}>
                                    <ButtonAtm
                                        fullWidth
                                        className={`room-rate-modal-save bg-red ${classes.saveButton}`}
                                        style={{marginTop: 40, marginLeft: 12}}
                                        buttontext={
                                            syncFetching 
                                                ? <CircularProgress size={20} color="inherit" /> 
                                                : (
                                                    <Box display="flex" alignItems="center" justifyContent="center">
                                                        <i className="fas fa-save" style={{ marginRight: 8 }} />
                                                        {t('btn-save')}
                                                    </Box>
                                                )
                                        }
                                        onClick={() => handleSave(channel.id)}
                                        disabled={syncFetching}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                ))}
            </MuiDialogContent>
        </Dialog>
    );
};

export default function ReputationManagementReviews() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const { channelId } = useParams();
    const modernFilter = useModernFilterStyles();
    
    const selectedReviewRef = useRef(null);

    const propertyProductsReducer = useSelector(state => state.propertyProductsReducer);
    const allowedPageReputationManagement = !propertyProductsReducer.fetching &&
        propertyProductsReducer.get_products &&
        Object.values(propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route);

    // Channel List State
    const channelListData = useSelector(state => state.reputationManagementReducer?.listData);
    const channelListFetching = useSelector(state => state.reputationManagementReducer?.listFetching);
    const syncData = useSelector(state => state.reputationManagementReducer?.syncData);
    const syncFetching = useSelector(state => state.reputationManagementReducer?.syncFetching);
    const syncError = useSelector(state => state.reputationManagementReducer?.syncError);

    const reviewData = useSelector(state => state.reputationManagementReducer?.reviewData);
    const reviewFetching = useSelector(state => state.reputationManagementReducer?.reviewFetching);
    // const statisticsData = useSelector(state => state.reputationManagementReducer?.reviewStatisticsData);
    // const statisticsFetching = useSelector(state => state.reputationManagementReducer?.reviewStatisticsFetching);

    const openAIResult = useSelector(state => state.openAIReducer?.listData);
    const [translatedReview, setTranslatedReview] = useState("");
    const [aiLoading, setAiLoading] = useState(false);
    const [aiSuggestAnswerLoading, setAiSuggestAnswerLoading] = useState(false);
    const [aiReviewSummaryLoading, setAiReviewSummaryLoading] = useState(false);
    const [aiSuggestAnswer, setAiSuggestAnswer] = useState("");
    const [aiReviewSummary, setAiReviewSummary] = useState("");
    const [aiActionType, setAiActionType] = useState(null);
    const [suggestionTone, setSuggestionTone] = useState("professional");
    const [translatedSuggestedAnswer, setTranslatedSuggestedAnswer] = useState("");
    const [aiSuggestAnswerTranslateLoading, setAiSuggestAnswerTranslateLoading] = useState(false);

    const [toneMenuAnchor, setToneMenuAnchor] = useState(null);

    const toneOptions = [
        { value: "professional", label: t('enw-tone-professional')},
        { value: "warm", label: t('enw-tone-warm')},
        { value: "neutral", label: t('enw-tone-neutral')}
    ];

    const [page, setPage] = useState(1);
    const [perPage] = useState(20);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);
    const [filterOpen, setFilterOpen] = useState(true);
    const [selectedReview, setSelectedReview] = useState(null);
    const [detailsOpen, setDetailsOpen] = useState(true);
    const [categoriesOpen, setCategoriesOpen] = useState(true);
    const [selectedChannelId, setSelectedChannelId] = useState("");
    const [sentimentOrder, setSentimentOrder] = useState("");
    const [copied, setCopied] = useState(false);
    const [keyword, setKeyword] = useState("");

    const languageList = useSelector(state => state.languagesReducer?.languages) || [];
    const [translateMenuAnchor, setTranslateMenuAnchor] = useState(null);
    const [translateSuggestedMenuAnchor, setTranslateSuggestedMenuAnchor] = useState(null);
    const [selectedTranslateLang, setSelectedTranslateLang] = useState(getAppLang() ?? 'tr');
    const [sentimentFilter, setSentimentFilter] = useState("");

    // Modal State
    const [channelModalOpen, setChannelModalOpen] = useState(false);

    //Snackbar
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    // Tüm kanalların status kontrolü
    const allChannelsInactive = channelListData?.every(
        channel => channel.channelDetail?.fetchStatus?.status === 0 || !channel.channelDetail
    );

    const hasActiveChannel = channelListData?.some(
        channel => channel.channelDetail?.fetchStatus?.status === 1
    );

    useEffect(() => {
        dispatch(reputationManagementList());

        return () => {
            dispatch(reputationManagementReviewClear());
            // dispatch(reputationManagementReviewStatisticsClear());
            dispatch(reputationManagementListClear());
            dispatch(reputationManagementSyncClear());
        }
    }, [dispatch]);

    useEffect(() => {
        dispatch(getLanguages());
    }, [dispatch]);

    // Kanal listesi yüklendikten sonra, aktif kanal varsa reviewları çek
    // useEffect(() => {
    //     if (channelListData && hasActiveChannel) {
    //         fetchReviews();
    //         // dispatch(reputationManagementReviewStatistics());
    //     }
    // }, [channelListData, hasActiveChannel]);

    // useEffect(() => {
    //     if (hasActiveChannel) {
    //         fetchReviews();
    //     }
    // }, [page]);

    useEffect(() => {
        if (channelListData && hasActiveChannel) {
            fetchReviews();
        }
    }, [channelListData, hasActiveChannel, page]);

    // İlk yorumu otomatik seç
    useEffect(() => {
        if (reviewData?.review?.length > 0 && !selectedReview) {
            setSelectedReview(reviewData.review[0]);
        }
    }, [reviewData]);

    useEffect(() => {
        if (openAIResult && typeof openAIResult === "object" && openAIResult.content) {
            if (aiActionType === "translate") {
                setTranslatedReview(openAIResult.content);
                setAiLoading(false);
            } else if (aiActionType === "suggestAnswer") {
                setAiSuggestAnswer(openAIResult.content);
                setAiSuggestAnswerLoading(false);
            } else if (aiActionType === "ReviewSummary") {
                setAiReviewSummary(openAIResult.content);
                setAiReviewSummaryLoading(false);
            } else if (aiActionType === "translateSuggestedAnswer") {
                setTranslatedSuggestedAnswer(openAIResult.content);
                setAiSuggestAnswerTranslateLoading(false);
            }
            dispatch(clearOpenAI());
            setAiActionType(null);
        }
    }, [openAIResult, dispatch, aiActionType]);

    useEffect(() => {
        setTranslatedReview("");
        setAiLoading(false);
        setAiSuggestAnswer("");
        setAiReviewSummary("");
        setTranslatedSuggestedAnswer("");
    }, [selectedReview]);

    // Sync başarılı olduğunda kanal listesini yeniden çek
    useEffect(() => {
        if (syncData) {
            dispatch(reputationManagementList());
            setChannelModalOpen(false);
            setSnackbarMessage(t('enw-reputation_management-channel_saved'));
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            dispatch(reputationManagementSyncClear());
        }
    }, [syncData]);

    useEffect(() => {
        if (syncError) {
            setSnackbarMessage(syncError?.response?.data?.message || t('enw-error-message'));
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            dispatch(reputationManagementSyncClear());
        }
    }, [syncError]);

    const handleChannelSave = (params) => {
        dispatch(reputationManagementSync(params));
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const fetchReviews = () => {
        const params = {
            page: page,
            per_page: perPage,
            start_date: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
            end_date: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
            channel_id: selectedChannelId ? parseInt(selectedChannelId) : null,
            keyword: keyword || null,
            sentiment: sentimentFilter !== "" ? Number(sentimentFilter) : null,
        };
        dispatch(reputationManagementReview(params));
    }

    const handleFilter = () => {
        setPage(1);
        setSelectedReview(null);
        fetchReviews();
    }

    const clearFilter = () => {
        setStartDate(null);
        setEndDate(null);
        setSelectedChannelId("");
        setKeyword("");
        setPage(1);
        setSelectedReview(null);
        setSentimentFilter("")
        const params = {
            page: 1,
            per_page: perPage,
            channel_id: channelId ? parseInt(channelId) : null,
        };
        dispatch(reputationManagementReview(params));
    }

    const getScoreColor = (score) => {
        if (score >= 80) return '#4caf50';
        if (score >= 60) return '#ff9800';
        return '#f44336';
    }

    const getBarColorClass = (score) => {
        if (score >= 80) return classes.barGreen;
        if (score >= 60) return classes.barOrange;
        return classes.barRed;
    };

    const getScoreClass = (score) => {
        if (score >= 80) return classes.reviewScore;
        if (score >= 60) return `${classes.reviewScore} ${classes.reviewScoreMedium}`;
        return `${classes.reviewScore} ${classes.reviewScoreLow}`;
    }

    const getScoreIcon = (score) => {
        if (score >= 80) return <i className="fas fa-smile" style={{ color: "#fff", marginRight: 6, fontSize: 14 }} />;
        if (score >= 60) return <i className="fas fa-meh" style={{ color: "#fff", marginRight: 6, fontSize: 14 }} />;
        return <i className="fas fa-frown" style={{ color: "#fff", marginRight: 6, fontSize: 14 }} />;
    };

    const getSentimentClass = (sentiment) => {
        if (sentiment === 1) return classes.sentimentPositive;
        if (sentiment === 0) return classes.sentimentNegative;
        return classes.sentimentNeutral;
    }

    const getSentimentText = (sentimentText) => {
        if (sentimentText === 'Positive') return t('enw-positive');
        if (sentimentText === 'Negative') return t('enw-negative');
        return t('enw-neutral');
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        setSelectedReview(null);
        setSentimentOrder("");
    }

    const selectReview = (review) => {
        setSelectedReview(review);

        if (window.innerWidth < 768 && selectedReviewRef.current) {
            selectedReviewRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const getTotalPages = () => {
        if (!reviewData?.total || !reviewData?.count) return 1;
        return Math.ceil(reviewData.total / perPage);
    }

    const getCategoriesBySentiment = (categoryMapping) => {
        const positive = categoryMapping?.filter(c => c.sentiment === 1) || [];
        const negative = categoryMapping?.filter(c => c.sentiment === 0) || [];
        return { positive, negative };
    }

    const handleTranslate = (langCode) => {
        if (selectedReview?.review) {
            setTranslatedReview("");
            setAiLoading(true);
            setAiActionType("translate");
            const langObj = languageList.find(l => l.code === langCode);
            const langName = langObj ? t(langObj.language_key) : langCode;
            const aiMessage = [
                {
                    role: "system",
                    content: `Sadece JSON formatında cevap ver. Key ismi 'content' olacak. Aşağıdaki metni ${langName} iso diline çevir.`
                },
                {
                    role: "user",
                    content: selectedReview.review
                }
            ];
            dispatch(openAI({ message: aiMessage }));
        }
    };

    const handleSuggestAnswerWithAI = () => {
        if (selectedReview?.review) {
            setAiSuggestAnswer("");
            setAiSuggestAnswerLoading(true);
            setAiActionType("suggestAnswer");
            let toneText = "";
            if (suggestionTone === "professional") toneText = "NAZİK ve PROFESYONEL";
            else if (suggestionTone === "warm") toneText = "SAMİMİ ve SICAK";
            else if (suggestionTone === "neutral") toneText = "ILIMLI ve NÖTR";
            else toneText = "NAZİK ve PROFESYONEL";

            const langText = selectedReview?.language ? `${selectedReview.language} iso dil kodu dilinde` : "yorumun dilini algıla ve yorumun dilinde";
            const aiMessage = [
                {
                    role: "system",
                    content: `Sadece JSON formatında cevap ver. Key ismi 'content' olacak. Aşağıdaki yoruma "${langText}", otel yetkilisi gibi ${toneText} bir cevap öner. YORUMU ÇEVİRME, SADECE CEVAP ÖNER.`
                },
                {
                    role: "user",
                    content: selectedReview?.title + " " + selectedReview.review
                }
            ];
            dispatch(openAI({ message: aiMessage }));
        }
    };

    const handleAIReviewSummary = () => {
        if (selectedReview?.review) {
            setAiReviewSummary("");
            setAiReviewSummaryLoading(true);
            setAiActionType("ReviewSummary");
            const aiMessage = [
                {
                    role: "system",
                    content: `Aşağıdaki kullanıcı yorumunu sadece "${getAppLang() + " iso dilinde" ?? 'Türkçe'}" olarak, kısa ve öz bir şekilde özetle. Yanıtın sadece "${getAppLang() + " iso dilinde" ?? 'Türkçe'}" olmalı, başka dil kullanma. Sadece JSON formatında cevap ver, key ismi 'content' olacak. YORUMU ÇEVİRME, SADECE TÜRKÇE KISA ÖZETLE.`
                },
                {
                    role: "user",
                    content: selectedReview?.title + " " + selectedReview.review
                }
            ];
            dispatch(openAI({ message: aiMessage }));
        }
    };

    const getLangName = (code) => {
        switch (code) {
            case "tr": return "türkçe";
            case "en": return "ingilizce";
            case "de": return "almanca";
            case "fr": return "fransızca";
            case "es": return "ispanyolca";
            case "ru": return "rusça";
            case "bg": return "bulgarca";
            case "ro": return "romence";
            case "pl": return "lehçe";
            case "ka": return "gürcüce";
            case "ar": return "arapça";
            default: return "türkçe";
        }
    };

    const handleTranslateSuggestedAnswer = (langCode) => {
        setSelectedTranslateLang(langCode ?? getAppLang() ?? 'tr');
        setTranslateSuggestedMenuAnchor(null);
        if (aiSuggestAnswer) {
            setTranslatedSuggestedAnswer("");
            setAiSuggestAnswerTranslateLoading(true);
            setAiActionType("translateSuggestedAnswer");
            const langObj = languageList.find(l => l.code === langCode);
            const langName = langObj ? t(langObj.language_key) : langCode;
            const aiMessage = [
                {
                    role: "system",
                    content: `Sadece JSON formatında cevap ver. Key ismi 'content' olacak. Aşağıdaki metni ${langName} iso diline çevir.`
                },
                {
                    role: "user",
                    content: aiSuggestAnswer
                }
            ];
            dispatch(openAI({ message: aiMessage }));
        }
    };

    const handleChannelChange = (e) => {
        setSelectedChannelId(e.target.value);
        setPage(1);
        // setSelectedReview(null);
    };

    const handleSentimentSort = () => {
        setSentimentOrder(prev => {
            if (prev === "") return "desc";
            if (prev === "desc") return "asc";
            return "";
        });
    };

    const handleCopySuggestAnswer = () => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(aiSuggestAnswer);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        } else {
            // (eski tarayıcılar için)
            const textArea = document.createElement("textarea");
            textArea.value = aiSuggestAnswer;
            textArea.style.position = "fixed";
            textArea.style.top = 0;
            textArea.style.left = 0;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                setCopied(true);
                setTimeout(() => setCopied(false), 3000);
            } catch (err) {
            }
            document.body.removeChild(textArea);
        }
    };

    // Kanal listesi yükleniyorsa loading göster
    if (channelListFetching) {
        return (
            <>
                <PageTitle title={t('enw-reputation_management-title')} />
                <PageHeaderAtm
                    backButton={REPUTATION_MANAGEMENT}
                    exitText={t('btn-dashboard')}
                    text={t('enw-reputation_management-title')}
                />
                <Backdrop className={classes.backdrop} open={true}>
                    <CircularProgress className='rm-circular-proggress' color="inherit" />
                </Backdrop>
            </>
        );
    }

    // Tüm kanallar inaktif ise kanal ekleme ekranı göster
    if (channelListData && allChannelsInactive) {
        return (
            <>
                <PageTitle title={t('enw-reputation_management-title')} />
                <PageHeaderAtm
                    backButton={REPUTATION_MANAGEMENT}
                    exitText={t('btn-dashboard')}
                    text={t('enw-reputation_management-title')}
                />
                <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                    <Container maxWidth="xl">
                        <div className="container-width">
                            <Paper className={classes.noChannelContainer}>
                                <i className="fas fa-comments-alt" style={{ fontSize: 80, color: '#e0e0e0', marginBottom: 32 }} />
                                <Typography variant="h5" style={{ marginBottom: 16, fontWeight: 600 }}>
                                    {t('enw-reputation_management-no_channel_title')}
                                </Typography>
                                <Typography variant="body1" color="textSecondary" style={{ marginBottom: 32, maxWidth: 500 }}>
                                    {t('enw-reputation_management-no_channel_desc')}
                                </Typography>
                                <ButtonAtm
                                    className="filter-action-button cpa-new-property-btn"
                                    buttontext={t('enw-reputation_management-add_channel')}
                                    onClick={() => setChannelModalOpen(true)}
                                    startIcon={<i style={{ fontSize: "12px", marginTop: "2px" }} className="fas fa-plus" />}
                                />
                            </Paper>
                        </div>
                    </Container>
                </Animated>
                
                <ChannelSetupModal
                    open={channelModalOpen}
                    onClose={() => setChannelModalOpen(false)}
                    channels={channelListData}
                    onSave={handleChannelSave}
                    syncFetching={syncFetching}
                    syncData={syncData}
                    syncError={syncError}
                />
            </>
        );
    }

    const getChannelExternalLink = (channelName) => {
        switch (channelName) {
            case "Booking.com":
                return "https://account.booking.com/sign-in";
            case "Google":
                return "https://business.google.com/";
            case "Tripadvisor":
                return "https://www.tripadvisor.com/RegistrationController";
            case "Agoda":
                return "https://www.agoda.com/en-gb/account/signin.html";
            case "Trip.com":
                return "https://trip.com";
            case "Expedia":
                return "https://www.expedia.com/login";
            default:
                return "#";
        }
    };

    function highlightKeyword(text, keyword) {
        if (!text) return "";
        if (!keyword) return text;
        const regex = new RegExp(`(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        return text.split(regex).map((part, i) =>
            regex.test(part)
                ? <span key={i} style={{ background: 'yellow', color: '#222' }}>{part}</span>
                : part
        );
    }

    if (!propertyProductsReducer.fetching && (!allowedPageReputationManagement[0] || !allowedPageReputationManagement[0].property_has_product)) {
        return (
            <Grid item xs={12} lg={6} className="no-buy-product">
                <Card className="p-24">
                    <NotAllowedPage />
                </Card>
            </Grid>
        );
    }

    return (
        <>
            <PageTitle title={t('enw-reputation_management-title') + " - " + t('myweb-section-google_reviews')} />
            <PageHeaderAtm 
                backButton={REPUTATION_MANAGEMENT} 
                exitText={t('btn-dashboard')} 
                text={t('enw-reputation_management-title')}
                rightButton={
                    <ButtonAtm
                        className="inventory-action-btn bg-dark-blue inventory-filter-box"
                        style={{padding: "2px 10px"}}
                        buttontext={t('enw-reputation_management-channel_settings')}
                        onClick={() => setChannelModalOpen(true)}
                        startIcon={<SettingsIcon style={{ fontSize: 16 }} />}
                    />
                }
            />
            <Backdrop className={classes.backdrop} open={reviewFetching}>
                <CircularProgress className='rm-circular-proggress' color="inherit" />
            </Backdrop>
            <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                <Container maxWidth="xl">
                    <div className="container-width">
                        {/* Statistics Section */}
                        {/* { statisticsData && (
                            <Paper className={classes.statisticsCard} elevation={2}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={3} style={{alignContent: "center"}}>
                                        <Typography variant="h6" style={{marginBottom: "20px"}} align="center">
                                            {t('enw-reputation_management-system_score')}
                                        </Typography>
                                        <Box 
                                            className={classes.scoreCircle} 
                                            style={{ backgroundColor: getScoreColor(statisticsData?.reviewScoreBySystem) }}
                                        >
                                            {statisticsData?.reviewScoreBySystem?.toFixed(1)}%
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Typography variant="h6" style={{marginBottom: "20px"}}>
                                            {t('enw-reputation_management-category_scores')}
                                        </Typography>
                                        <Grid container spacing={2}>
                                            {statisticsData?.reviewCategoryScoreBySystem?.slice().sort((a, b) => ((b.negative + b.positive) - (a.negative + a.positive))).map((category, index) => (
                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                    <Box className={classes.categoryScore}>
                                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                                            <Typography variant="body2" style={{marginBottom: 2}}>{t(category?.language_key ?? category?.name)}</Typography>
                                                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                                {category?.score?.toFixed(0)}%
                                                            </Typography>
                                                        </Box>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={category?.score}
                                                            className={classes.progressBar}
                                                            style={{ backgroundColor: '#e0e0e0' }}
                                                            classes={{
                                                                bar: getBarColorClass(category?.score)
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        )} */}

                        {/* Filter Section */}
                        <Paper className={modernFilter.filterPaper} elevation={0}>
                            <Box
                                className={modernFilter.filterHeader}
                                onClick={() => setFilterOpen(!filterOpen)}
                                tabIndex={0}
                                role="button"
                            >
                                <Box className={modernFilter.filterHeaderLeft}>
                                    <span className={modernFilter.filterIcon}>
                                        <FilterListIcon style={{ color: "#fff", fontSize: 24 }} />
                                    </span>
                                    <Box>
                                        <Typography className={modernFilter.filterTitle}>
                                            {t('enw-table-toolbar-filters')}
                                        </Typography>
                                        <Typography className={modernFilter.filterDesc}>
                                            {t('enw-filter-reviews-description')}
                                        </Typography>
                                    </Box>
                                </Box>
                                <IconButton>
                                    {filterOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>
                            <Collapse in={filterOpen} className={modernFilter.filterCollapse}>
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item xs={12} md={3}>
                                        <FormControl variant="outlined" fullWidth>
                                            <Select
                                                value={selectedChannelId}
                                                onChange={handleChannelChange}
                                                className={modernFilter.filterInput}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    {t('enw-tab-all')}
                                                </MenuItem>
                                                {channelListData?.map(channel => (
                                                    <MenuItem key={channel.id} value={channel.id}>
                                                        {/* <img src={channel?.logoUrl} style={{ width: 65, height: "100%", marginRight: 6 }} alt={channel.name} /> */} {channel.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel>{t('enw-reputation_management-filter_by_sentiment')}</InputLabel>
                                            <Select
                                                value={sentimentFilter}
                                                onChange={e => setSentimentFilter(e.target.value)}
                                                label={t('enw-reputation_management-filter_by_sentiment')}
                                                className={modernFilter.filterInput}
                                            >
                                                <MenuItem value="">{t('enw-tab-all')}</MenuItem>
                                                <MenuItem value="1">{t('enw-positive')}</MenuItem>
                                                <MenuItem value="0">{t('enw-negative')}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box 
                                            className={modernFilter.filterInput} 
                                            style={{ 
                                                padding: window.innerWidth > 768 ? 8 : 12, 
                                                textAlign: "center",
                                                marginTop: "1.5rem",
                                                border: "1px solid #8f94a2",
                                                borderRadius: "8px",
                                                height: "56px"
                                            }}
                                        >
                                            <DateRangePicker
                                                startDate={startDate}
                                                startDateId="filter_start_date"
                                                endDate={endDate}
                                                endDateId="filter_end_date"
                                                onDatesChange={({ startDate, endDate }) => {
                                                    setStartDate(startDate);
                                                    setEndDate(endDate);
                                                }}
                                                focusedInput={focusedInput}
                                                onFocusChange={focusedInput => setFocusedInput(focusedInput)}
                                                isOutsideRange={() => false}
                                                displayFormat="DD/MM/YYYY"
                                                startDatePlaceholderText={t('enw-input-from_date')}
                                                endDatePlaceholderText={t('enw-input-to_date')}
                                                numberOfMonths={window.innerWidth > 768 ? 2 : 1}
                                                noBorder
                                                small
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <InputAtm
                                            fullWidth
                                            label=""
                                            value={keyword}
                                            onChange={e => setKeyword(e.target.value)}
                                            placeholder={t('btn-search')}
                                            variant="outlined"
                                            className={modernFilter.filterInput}
                                            InputProps={{
                                                startAdornment: (
                                                    <i className="fas fa-search" style={{ marginRight: 10, color: "#9ca3af", fontSize: 16 }} />
                                                ),
                                                endAdornment: (
                                                    keyword ? (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="clear input"
                                                                size="small"
                                                                onClick={() => setKeyword("")}
                                                                edge="end"
                                                            >
                                                                <ClearIcon style={{ fontSize: 18, color: "#b0b0b0" }} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ) : null
                                                )
                                            }}
                                            onKeyDown={e => {
                                                if (e.key === "Enter") {
                                                    handleFilter();
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Box className={modernFilter.filterActions + " rm-filter-actions"}>
                                    <ButtonAtm
                                        className={modernFilter.filterBtn + " " + modernFilter.filterBtnApply + " mobile-w-100"}
                                        buttontext={t('enw-table-toolbar-filters')}
                                        onClick={handleFilter}
                                    />
                                    <ButtonAtm
                                        className={modernFilter.filterBtn + " " + modernFilter.filterBtnClear + " mobile-w-100"}
                                        buttontext={t('btn-clear')}
                                        onClick={clearFilter}
                                        disabled={!startDate && !endDate && !selectedChannelId && !keyword}
                                    />
                                </Box>
                            </Collapse>
                        </Paper>

                        {/* Reviews Section */}
                        <Grid container spacing={3}>
                            {/* Review List */}
                            <Grid item xs={12} md={4}>
                                <Paper style={{ padding: 16 }}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <Typography variant="h6">
                                            {t('enw-reputation_management-recent_comments')}
                                        </Typography>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            {/* <Tooltip
                                                PopperProps={{ disablePortal: true }}
                                                placement="top"
                                                title={<span style={{fontSize: "16px", color: "inherit" }}>{t('enw-reputation_management-filter_by_sentiment')}</span>}
                                            >
                                            <IconButton
                                                onClick={handleSentimentSort}
                                                style={{ marginRight: 4 }}
                                            >
                                                <i
                                                    className="fas fa-sort-amount-up-alt"
                                                    style={{
                                                        color: sentimentOrder === "desc" ? "#4caf50" : sentimentOrder === "asc" ? "#f44336" : "#888",
                                                        transform: sentimentOrder === "asc" ? "rotate(180deg)" : "rotate(0deg)",
                                                        transition: "color 0.2s",
                                                        marginTop: 2
                                                    }}
                                                />
                                            </IconButton>
                                            </Tooltip>*/}
                                            {reviewData?.total && (
                                                <Chip 
                                                    label={`${t('web-offer-total')}: ${reviewData?.total}`}
                                                    size="small"
                                                    variant="outlined"
                                                />
                                            )}
                                        </Box> 
                                    </Box>
                                    <Divider style={{ marginBottom: 16 }} />
                                    <Box className={classes.reviewListContainer}>
                                        {(reviewData?.review || [])
                                            .slice()
                                            .sort((a, b) => {
                                                if (sentimentOrder === "desc") return b.sentiment - a.sentiment;
                                                if (sentimentOrder === "asc") return a.sentiment - b.sentiment;
                                                return 0;
                                            })
                                            .map((review) => (
                                            <Card 
                                                key={review?.id} 
                                                className={`${classes.reviewCard} ${selectedReview?.id === review?.id ? classes.selectedReview : ''}`}
                                                onClick={() => selectReview(review)}
                                            >
                                                <CardContent style={{ padding: 12 }}>
                                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                                        <span className={getScoreClass(review?.score)}>
                                                            {getScoreIcon(review?.score)}
                                                            {review?.rating}/{review?.top_rating}
                                                        </span>
                                                        <Typography variant="caption" color="textSecondary">
                                                            {moment(review?.review_date).locale(i18n.language).format('DD MMM YYYY')}
                                                        </Typography>
                                                    </Box>
                                                    
                                                    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4 }}>
                                                        {review?.author}
                                                    </Typography>
                                                    
                                                    {review?.title && (
                                                        <Typography variant="body2" style={{ fontWeight: 500, marginBottom: 4 }}>
                                                            {review?.title}
                                                        </Typography>
                                                    )}
                                                    
                                                    <Typography 
                                                        variant="body2" 
                                                        color="textSecondary" 
                                                        style={{ 
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical',
                                                        }}
                                                    >
                                                        {highlightKeyword(review?.review, keyword)}
                                                    </Typography>
                                                    
                                                    <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
                                                        <img 
                                                            src={review?.channel?.logoUrl} 
                                                            alt={review?.channel?.name}
                                                            style={{ width: 90, height: 50, objectFit: 'contain' }}
                                                        />
                                                        {review?.sentimentText && (
                                                            <Typography 
                                                                variant="caption" 
                                                                className={getSentimentClass(review?.sentiment)}
                                                            >
                                                                {getSentimentText(review?.sentimentText)}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        ))}
                                        
                                        {(!reviewData?.review || reviewData?.review.length === 0) && !reviewFetching && (
                                            <Box textAlign="center" py={4}>
                                                <Typography variant="body2" color="textSecondary">
                                                    {t('enw-no_reviews_found')}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    
                                    {/* Pagination */}
                                    {getTotalPages() > 1 && (
                                        <Box display="flex" justifyContent="center" style={{ marginTop: 16 }}>
                                            <Pagination 
                                                count={getTotalPages()} 
                                                page={page} 
                                                onChange={handlePageChange}
                                                color="primary"
                                                size="small"
                                            />
                                        </Box>
                                    )}
                                </Paper>
                            </Grid>

                            {/* Selected Review Detail */}
                            <Grid item xs={12} md={8} ref={selectedReviewRef}>
                                {selectedReview ? (
                                    <Paper style={{ padding: 24 }}>
                                        {/* Header */}
                                        <Box className={classes.reviewHeader}>
                                            <Box>
                                                <Typography variant="h5" style={{ fontWeight: 600 }}>
                                                    {selectedReview?.author}
                                                </Typography>
                                                <Typography variant="body2" className='mt-4' color="textSecondary">
                                                    {moment(selectedReview?.review_date).locale(i18n.language).format('DD MMMM YYYY HH:mm')}
                                                </Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                <span className={getScoreClass(selectedReview?.score)} style={{ fontSize: 18, padding: '6px 16px' }}>
                                                    <span className='rm-rating-icons'>{getScoreIcon(selectedReview?.score)}</span>
                                                    {selectedReview?.rating}/{selectedReview?.top_rating}
                                                </span>
                                            </Box>
                                        </Box>

                                        {/* Sentiment & Channel */}
                                        <Box display="flex" alignItems="center" mt={2} mb={2}>
                                            {selectedReview?.sentimentText && (
                                                <Chip 
                                                    label={getSentimentText(selectedReview?.sentimentText)}
                                                    size="small"
                                                    className={selectedReview?.sentiment === 1 ? classes.positiveChip : classes.negativeChip}
                                                    style={{ marginRight: 8 }}
                                                />
                                            )}
                                            {
                                                selectedReview?.language && 
                                                    <Chip
                                                        label={selectedReview?.language?.toUpperCase()}
                                                        size="small"
                                                        variant="outlined"
                                                        style={{ marginRight: 8 }}
                                                    />
                                            }
                                            <img 
                                                src={selectedReview?.channel?.logoUrl} 
                                                alt={selectedReview?.channel?.name}
                                                style={{ width: 80, height: 40, objectFit: 'contain' }}
                                            />
                                        </Box>

                                        {/* Positive / Negative Categories */}
                                        {(() => {
                                            const { positive, negative } = getCategoriesBySentiment(selectedReview?.category_mapping);
                                            return (
                                                <Grid container spacing={2}>
                                                    {positive?.length > 0 && (
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="caption" className={classes.sentimentPositive} style={{ display: 'block', marginBottom: 8 }}>
                                                                <i className="fas fa-thumbs-up" style={{ marginRight: 4 }} />
                                                                {t('enw-positive')}
                                                            </Typography>
                                                            <Box display="flex" flexWrap="wrap">
                                                                {positive.map((cat) => (
                                                                    <Chip
                                                                        key={cat?.id}
                                                                        label={t(cat?.category?.language_key ?? cat?.category?.name) }
                                                                        size="small"
                                                                        className={classes.positiveChip + " rm-positive-chip"}
                                                                        style={{
                                                                            backgroundColor: "#4caf50",
                                                                            color: "#fff",
                                                                            fontWeight: 500
                                                                        }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                    {negative?.length > 0 && (
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography variant="caption" className={classes.sentimentNegative} style={{ display: 'block', marginBottom: 8 }}>
                                                                <i className="fas fa-thumbs-down" style={{ marginRight: 4 }} />
                                                                {t('enw-negative')}
                                                            </Typography>
                                                            <Box display="flex" flexWrap="wrap">
                                                                {negative.map((cat) => (
                                                                    <Chip
                                                                        key={cat?.id}
                                                                        label={t(cat?.category?.language_key ?? cat?.category?.name)}
                                                                        size="small"
                                                                        className={classes.negativeChip + " rm-negative-chip"}
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontWeight: 500
                                                                        }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            );
                                        })()}
                                        
                                        {/* Title */}
                                        {selectedReview?.title && (
                                            <Typography variant="h6" style={{ marginBottom: 16, marginTop: 16, fontWeight: 500 }}>
                                                "{selectedReview?.title}"
                                            </Typography>
                                        )}

                                        {/* Review Text */}
                                        <Box className={classes.reviewText}>
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Typography variant="body1" style={{ lineHeight: 1.7, width: "100%" }}>
                                                    {/* {selectedReview?.review} */}
                                                    {highlightKeyword(selectedReview?.review, keyword)}
                                                    {translatedReview && (
                                                        <Box mt={2}>
                                                            <Divider style={{ margin: "8px 0" }} />
                                                            <Typography variant="body" color="primary" style={{ fontSize: 15, lineHeight: 1.7, fontStyle: "italic" }}>
                                                                {translatedReview}
                                                                <span className='mt-12' style={{fontStyle: "italic", fontSize: "14px", display: "block", fontWeight: 600}}>
                                                                <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20, marginRight: 4}} viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                                                                {t('enw-reputation_management-translated_by')}
                                                                </span>
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                    {selectedReview?.review && (
                                                        <Box display="flex" justifyContent="space-between" className='mt-22 rm-ai-btns-box' flex="1" gap={2}>
                                                            <Box display="flex" className='rm-review-btns' gap={2} alignItems="center">
                                                                 <Box 
                                                                    display="flex"
                                                                    className='rm-sugges-box'
                                                                    alignItems="stretch"
                                                                    style={{
                                                                        borderRadius: 4,
                                                                        overflow: 'hidden',
                                                                        border: '1px solid #e0e0e0',
                                                                        background: '#fff',
                                                                        marginRight: 12
                                                                    }}
                                                                >
                                                                    {/* Main Button */}
                                                                    <ButtonAtm
                                                                        className="bg-blue review-ai-btns"
                                                                        startIcon={
                                                                            aiSuggestAnswerLoading
                                                                                ? <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                                                                : <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26", marginLeft: "8px"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                                                                    <path d="M20 3v4"></path>
                                                                                    <path d="M22 5h-4"></path>
                                                                                    <path d="M4 17v2"></path>
                                                                                    <path d="M5 18H3"></path>
                                                                                </svg>
                                                                        }
                                                                        buttontext={
                                                                            <span>
                                                                                {t('enw-suggest_answer')}: <strong>{toneOptions.find(opt => opt.value === suggestionTone)?.label}</strong>
                                                                            </span>
                                                                        }
                                                                        onClick={handleSuggestAnswerWithAI}
                                                                        disabled={aiSuggestAnswerLoading || aiLoading || aiReviewSummaryLoading || aiSuggestAnswerTranslateLoading}
                                                                        style={{ 
                                                                            minWidth: 180, 
                                                                            textTransform: "none",
                                                                            borderRadius: 0,
                                                                            borderRight: 'none'
                                                                        }}
                                                                    />
                                                                    {/* Dropdown Arrow Button */}
                                                                    <Box
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setToneMenuAnchor(e.currentTarget);
                                                                        }}
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            padding: '0 8px',
                                                                            borderLeft: '1px solid #d0d0d0',
                                                                            cursor: 'pointer',
                                                                            background: '#f5f5f5',
                                                                            transition: 'background 0.2s ease'
                                                                        }}
                                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#e8e8e8'}
                                                                        onMouseLeave={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                                                    >
                                                                        <ArrowDropDownIcon style={{ fontSize: 22, color: '#555' }} />
                                                                    </Box>
                                                                    <Menu
                                                                        anchorEl={toneMenuAnchor}
                                                                        open={Boolean(toneMenuAnchor)}
                                                                        onClose={() => setToneMenuAnchor(null)}
                                                                        getContentAnchorEl={null}
                                                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                        PaperProps={{
                                                                            style: {
                                                                                borderRadius: 4,
                                                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                                                minWidth: 160
                                                                            }
                                                                        }}
                                                                    >
                                                                        {toneOptions.map(option => (
                                                                            <MenuItem
                                                                                key={option.value}
                                                                                selected={suggestionTone === option.value}
                                                                                onClick={() => {
                                                                                    setSuggestionTone(option.value);
                                                                                    setToneMenuAnchor(null);
                                                                                }}
                                                                                style={{
                                                                                    padding: '10px 16px',
                                                                                    fontSize: 14
                                                                                }}
                                                                            >
                                                                                {option.label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Menu>
                                                                </Box>
                                                                {selectedReview?.review && (
                                                                    <ButtonAtm
                                                                        className="bg-blue review-ai-btns ml-9 rm-summary-btn"
                                                                        startIcon={
                                                                            aiReviewSummaryLoading
                                                                                ? <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                                                                : <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26", marginLeft: "8px"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                                                                    <path d="M20 3v4"></path>
                                                                                    <path d="M22 5h-4"></path>
                                                                                    <path d="M4 17v2"></path>
                                                                                    <path d="M5 18H3"></path>
                                                                                </svg>
                                                                        }
                                                                        buttontext={t('enw-reputation_management_summary_review')}
                                                                        onClick={handleAIReviewSummary}
                                                                        disabled={aiSuggestAnswerLoading || aiLoading || aiReviewSummaryLoading || aiSuggestAnswerTranslateLoading}
                                                                        style={{ minWidth: 90, textTransform: "none" }}
                                                                    />
                                                                )}
                                                            </Box>
                                                            {/* Translate the review */}
                                                            {selectedReview?.language !== getAppLang() && (
                                                            <Box display="flex" justifyContent="flex-end">
                                                                <ButtonAtm
                                                                    className="bg-blue review-ai-btns ai-translate-btn"
                                                                    startIcon={
                                                                        aiLoading
                                                                            ? <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                                                            : <svg fill="#d71f26" style={{width: "1.5rem", height: "1.1rem", fontSize: 20, marginRight: 2}} viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                                                                    }
                                                                    buttontext={t('btn-translate')}
                                                                    onClick={e => setTranslateMenuAnchor(e.currentTarget)}
                                                                    disabled={aiLoading || aiSuggestAnswerLoading || aiReviewSummaryLoading || aiSuggestAnswerTranslateLoading}
                                                                    style={{ minWidth: 90, marginLeft: 16, textTransform: "none" }}
                                                                />
                                                                <Menu
                                                                    anchorEl={translateMenuAnchor}
                                                                    open={Boolean(translateMenuAnchor)}
                                                                    onClose={() => setTranslateMenuAnchor(null)}
                                                                    getContentAnchorEl={null}
                                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                >
                                                                    {languageList.map(lang => (
                                                                        <MenuItem
                                                                            key={"review_translate_" + lang.code}
                                                                            selected={selectedTranslateLang === lang.code}
                                                                            onClick={() => {
                                                                                setSelectedTranslateLang(lang.code);
                                                                                setTranslateMenuAnchor(null);
                                                                                handleTranslate(lang.code);
                                                                            }}
                                                                        >
                                                                            <img src={`/assets/img/language/${lang.code}.svg`} alt={lang.code} style={{ width: 20, marginRight: 8 }} />
                                                                            {t(lang.language_key)}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Menu>
                                                            </Box>
                                                        )}
                                                        </Box>
                                                    )}
                                                </Typography>
                                            </Box>
                                            {aiSuggestAnswer && (
                                                <Box mt={4}>
                                                    <Paper elevation={3} style={{
                                                        background: "#f4f8fd",
                                                        borderLeft: "2px solid #1976d2",
                                                        borderRadius: 6,
                                                        padding: "20px 24px",
                                                        marginTop: 24,
                                                        marginBottom: 24,
                                                        boxShadow: "0 2px 12px rgba(25, 118, 210, 0.08)",
                                                        position: "relative"
                                                    }}>
                                                        <Box className='rm-suggested-answer-tools' position="absolute" top={16} right={16} display="flex" alignItems="center" gap={1}>
                                                            <a
                                                                href={getChannelExternalLink(selectedReview?.channel?.name)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <IconButton style={{ fontSize: 20 }}>
                                                                    <i className="fas fa-external-link" />
                                                                </IconButton>
                                                            </a>
                                                            <Tooltip PopperProps={{ disablePortal: true }} title={copied ? t('btn-copied') : t('btn-copy')}>
                                                                <IconButton
                                                                    style={{ fontSize: 20 }}
                                                                    onClick={handleCopySuggestAnswer}
                                                                >
                                                                    {copied
                                                                        ? <i className="fas fa-check icon-anim" style={{ color: "#4caf50" }} />
                                                                        : <i className="far fa-clone icon-anim" />
                                                                    }
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                        <Box display="flex" alignItems="center" mb={1}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26", marginRight: "8px"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                                                <path d="M20 3v4"></path>
                                                                <path d="M22 5h-4"></path>
                                                                <path d="M4 17v2"></path>
                                                                <path d="M5 18H3"></path>
                                                            </svg>
                                                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#1976d2" }}>
                                                                {t('enw-ai_suggested_answer')}
                                                            </Typography>
                                                        </Box>
                                                        <Divider style={{ margin: "8px 0 16px 0" }} />
                                                        <Typography variant="body1" style={{ fontSize: 16, lineHeight: 1.8, fontStyle: "italic", color: "#222" }}>
                                                            {aiSuggestAnswer}
                                                        </Typography>
                                                        {/* Translate the suggested answer */}
                                                        {selectedReview?.language !== getAppLang() &&
                                                            <Box display="flex" justifyContent="flex-end">
                                                                <ButtonAtm
                                                                    className="bg-blue review-ai-btns ai-translate-btn"
                                                                    startIcon={aiSuggestAnswerTranslateLoading
                                                                        ? <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                                                        : <svg fill="#d71f26" style={{width: "1.5rem", height: "1.1rem", fontSize: 20, marginRight: 2}} viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                                                                    }
                                                                    buttontext={t('btn-translate')}
                                                                    onClick={e => setTranslateSuggestedMenuAnchor(e.currentTarget)}
                                                                    disabled={aiSuggestAnswerLoading || aiSuggestAnswerTranslateLoading}
                                                                    style={{ minWidth: 90, marginLeft: 16, textTransform: "none" }}
                                                                />
                                                                <Menu
                                                                    anchorEl={translateSuggestedMenuAnchor}
                                                                    open={Boolean(translateSuggestedMenuAnchor)}
                                                                    onClose={() => setTranslateSuggestedMenuAnchor(null)}
                                                                    getContentAnchorEl={null}
                                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                >
                                                                    {languageList.map(lang => (
                                                                        <MenuItem
                                                                            key={"suggested_translate_" + lang.code}
                                                                            selected={selectedTranslateLang === lang.code}
                                                                            onClick={() => handleTranslateSuggestedAnswer(lang.code)}
                                                                        >
                                                                            <img src={`/assets/img/language/${lang.code}.svg`} alt={lang.code} style={{ width: 20, marginRight: 8 }} />
                                                                            {t(lang.language_key)}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Menu>
                                                            </Box>
                                                        }
                                                        {/* Translated suggested answer */}
                                                        {translatedSuggestedAnswer && (
                                                            <Box mt={2}>
                                                                <Divider style={{ margin: "8px 0" }} />
                                                                <Typography variant="body2" color="primary" style={{ fontSize: 15, lineHeight: 1.7, fontStyle: "italic"}}>
                                                                    {translatedSuggestedAnswer}
                                                                    <span style={{fontStyle: "italic", fontSize: "14px", display: "block", fontWeight: 600, marginTop: 8 }}>
                                                                        <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20, marginRight: 4}} viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                                                                        {t('enw-reputation_management-translated_by')}
                                                                    </span>
                                                                </Typography>
                                                            </Box>
                                                        )}
                                                    </Paper>
                                                </Box>
                                            )}
                                            {aiReviewSummary && (
                                                <Box mt={4}>
                                                    <Paper elevation={3} style={{
                                                        background: "#f4f8fd",
                                                        borderLeft: "2px solid #1976d2",
                                                        borderRadius: 6,
                                                        padding: "20px 24px",
                                                        marginTop: 24,
                                                        marginBottom: 24,
                                                        boxShadow: "0 2px 12px rgba(25, 118, 210, 0.08)"
                                                    }}>
                                                        <Box display="flex" alignItems="center" mb={1}>
                                                            <i className="fas fa-lightbulb" style={{color: "#1976d2", marginRight: 8, fontSize: 22}} />
                                                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#1976d2" }}>
                                                                {t('enw-ai_review_summary')}
                                                            </Typography>
                                                        </Box>
                                                        <Divider style={{ margin: "8px 0 16px 0" }} />
                                                        <Typography variant="body1" style={{ fontSize: 16, lineHeight: 1.8, fontStyle: "italic", color: "#222" }}>
                                                            {aiReviewSummary}
                                                        </Typography>
                                                    </Paper>
                                                </Box>
                                            )}
                                        </Box>

                                        {/* Categories Section */}
                                        {/* {selectedReview?.category_mapping?.length > 0 && (
                                            <Box className={classes.categorySection}>
                                                <Box 
                                                    display="flex" 
                                                    justifyContent="space-between" 
                                                    alignItems="center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setCategoriesOpen(!categoriesOpen)}
                                                >
                                                    <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                                        {t('enw-categories')} ({selectedReview?.category_mapping.length})
                                                    </Typography>
                                                    <IconButton size="small">
                                                        {categoriesOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                    </IconButton>
                                                </Box>
                                                <Collapse in={categoriesOpen}>
                                                    <Box mt={2}>
                                                        {(() => {
                                                            const { positive, negative } = getCategoriesBySentiment(selectedReview?.category_mapping);
                                                            return (
                                                                <Grid container spacing={2}>
                                                                    {positive?.length > 0 && (
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Typography variant="caption" className={classes.sentimentPositive} style={{ display: 'block', marginBottom: 8 }}>
                                                                                <i className="fas fa-thumbs-up" style={{ marginRight: 4 }} />
                                                                                {t('enw-positive')}
                                                                            </Typography>
                                                                            <Box display="flex" flexWrap="wrap">
                                                                                {positive.map((cat) => (
                                                                                    <Chip
                                                                                        key={cat?.id}
                                                                                        label={t(cat?.category?.language_key ?? cat?.category?.name) }
                                                                                        size="small"
                                                                                        className={classes.positiveChip}
                                                                                    />
                                                                                ))}
                                                                            </Box>
                                                                        </Grid>
                                                                    )}
                                                                    {negative?.length > 0 && (
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Typography variant="caption" className={classes.sentimentNegative} style={{ display: 'block', marginBottom: 8 }}>
                                                                                <i className="fas fa-thumbs-down" style={{ marginRight: 4 }} />
                                                                                {t('enw-negative')}
                                                                            </Typography>
                                                                            <Box display="flex" flexWrap="wrap">
                                                                                {negative.map((cat) => (
                                                                                    <Chip
                                                                                        key={cat?.id}
                                                                                        label={t(cat?.category?.language_key ?? cat?.category?.name)}
                                                                                        size="small"
                                                                                        className={classes.negativeChip}
                                                                                    />
                                                                                ))}
                                                                            </Box>
                                                                        </Grid>
                                                                    )}
                                                                </Grid>
                                                            );
                                                        })()}
                                                    </Box>
                                                </Collapse>
                                            </Box>
                                        )} */}

                                        <Divider style={{ margin: '24px 0' }} />
                                        {/* Details Section */}
                                        <Box>
                                            <Box 
                                                display="flex" 
                                                justifyContent="space-between" 
                                                alignItems="center"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setDetailsOpen(!detailsOpen)}
                                            >
                                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                                    {t('btn-details')}
                                                </Typography>
                                                <IconButton size="small">
                                                    {detailsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                </IconButton>
                                            </Box>
                                            <Collapse in={detailsOpen}>
                                                <Box className={classes.detailsSection}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6} sm={4}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                {t('enw-reputation_management-source')}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {selectedReview?.channel?.name}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sm={4}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                {t('enw-input-date')}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {moment(selectedReview?.review_date).locale(i18n.language).format('DD MMM YYYY HH:mm')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sm={4}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                {t('enw-input-language')}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {selectedReview?.language?.toUpperCase() || '-'}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sm={4}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                {t('input-name')}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {selectedReview?.author || '-'}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sm={4}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                {t('enw-channel-score-title')}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {selectedReview?.score}%
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sm={4}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                {t('enw-rating')}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {selectedReview?.rating} / {selectedReview?.top_rating}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Collapse>
                                        </Box>
                                    </Paper>
                                ) : (
                                    <Paper className={classes.noReviewSelected}>
                                        <i className="fas fa-comments" style={{ fontSize: 64, color: '#e0e0e0', marginBottom: 24 }} />
                                        <Typography variant="h6" color="textSecondary">
                                            {t('enw-reputation_management-select_review')}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                                            {t('enw-reputation_management-select_review_desc')}
                                        </Typography>
                                    </Paper>
                                )}
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </Animated>

            {/* Channel Setup Modal */}
            {/* <ChannelSetupModal
                open={channelModalOpen}
                onClose={() => setChannelModalOpen(false)}
                channels={channelListData}
                onSave={handleChannelSave}
                syncFetching={syncFetching}
                syncData={syncData}
                syncError={syncError}
            /> */}

            {/* Snackbar */}
            <Snackbar 
                open={snackbarOpen} 
                autoHideDuration={3000} 
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <AlertSnackbar onClose={handleSnackbarClose} severity={snackbarSeverity}>
                    {snackbarMessage}
                </AlertSnackbar>
            </Snackbar>
          <style>{`
                .rm-form-control {
                    margin-bottom: 20px !important;
                }
                .review-ai-btns:disabled {
                    color: #000 !important;
                }
                .ai-translate-btn span {
                    margin-right:4px !important;
                }
            `}</style>  
        </>
    )
}